import React, { useState, useEffect } from "react";
import Location from './location'
import Duration from './duration'
import HourlyRate from './hourly-rate'
import Overtime from './overtime'
import ShiftSchedule from './shift-schedule'




const Calculate = ({ getContractDetails }) => {


        const [next, setNext] = useState(0);
    

    useEffect(() => {

        document.title = 'Roam Pays: Calculate your tax';

    }, []);


    const moveNext = async (n) => {
    
        setNext(n);

    }



    return (


        <div className="card" >

            <div className="card-title" >

                <div className="box-title color-white fs-18 fs-helvetica" >

                    Contract Details

                </div>



            </div>

            <div className="card-content" >


                <div className="input-container" >
                    <label >Location</label>

                    <Location getContractDetails={getContractDetails}  moveNext={moveNext} />


                </div>



                <div className="input-container" >
                    <label >Duration</label>

                    <Duration getContractDetails={getContractDetails}  moveNext={moveNext} next={next} />



                </div>

                <div className="fd-row g-12 align-self-stretch" >
                    <div className="input-container" >
                        <label >Hourly Rate</label>

                        <HourlyRate getContractDetails={getContractDetails}  moveNext={moveNext} next={next} />




                    </div>

                    <div className="input-container" >
                        <label >Overtime</label>

                        <Overtime getContractDetails={getContractDetails} moveNext={moveNext} next={next} />


                    </div>
                </div>

                <div className="input-container" >
                    <label >Shift Schedule</label>

                    <ShiftSchedule getContractDetails={getContractDetails} next={next} />


                </div>



            </div>





        </div>






    );
};

export default Calculate;